// Package Imports
import React from 'react';
import { Form, InputNumber } from 'antd';

// Project Imports
import regex from 'core/constants/Regex';
import { NumberInputProps } from 'components/number/type';

const PureNumberInput = ({
  label,
  name,
  required,
  message,
  style,
  values,
  disabled,
  onChange,
  placeholder,
  // rules,
  min,
  max,
}: NumberInputProps) => (
  <div
    className={
      disabled
        ? 'floating-disabled relative custom-border pure-number-input'
        : 'relative custom-border pure-number-input'
    }
  >
    {label ? (
      <label className="floating-label">
        {label} {required ? <span className="a8-error">*</span> : null}
      </label>
    ) : null}
    <Form.Item
      name={typeof name === 'string' ? [name] : [...name]}
      rules={[
        // { ...rules },
        {
          pattern: regex.noTags,
          message: 'Input must not contain HTML or XML tags.',
        },
        {
          required,
          pattern: regex.numberCheck,
          message,
        },
      ]}
      hasFeedback={required || !!values}
      style={style}
    >
      <InputNumber
        className="input-number w-full"
        value={values}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        max={max}
        min={min}
        controls={false}
        // onMouseEnter={event=>{
        //   const input=event.currentTarget as HTMLElement
        //   input.addEventListener(
        //     'wheel',
        //     e=>e.preventDefault(),
        //     {passive:false}
        //   )
        // }}
        // onKeyDown={e=>{
        //   if(e.key==='ArrowUp' || e.key==='ArrowDown'){
        //     e.preventDefault();
        //   }
        // }}
        //  onFocus={event=>{
        //   const input=event.currentTarget as HTMLElement
        //   input.addEventListener(
        //     'wheel',
        //     e=>e.preventDefault(),
        //     {passive:false}
        //   )
        // }}
        // onBlur={event=>{
        //   const input=event.currentTarget as HTMLElement
        //   input.addEventListener(
        //     'wheel',
        //     e=>e.preventDefault(),
        //     {passive:false}
        //   )
        // }}
        //  onWheel={(e) => e.currentTarget.blur()}
      />
    </Form.Item>
  </div>
);

export default PureNumberInput;
